import { DocumentCheckIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedHipaaGenerationAuditEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface DocumentHipaaPackageGenerationAuditEventProps {
  event: DiscriminatedHipaaGenerationAuditEvent;
}

export const DocumentHipaaPackageGenerationAuditEvent: React.FC<
  DocumentHipaaPackageGenerationAuditEventProps
> = ({ event }) => {
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-purple-100">
          <DocumentCheckIcon className="h-4 w-4 text-purple-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityDescription>
        <div className="text-sm text-gray-600">
          HIPAA authorization package created
        </div>
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="HIPAA Package Generated"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
